import React, { useState, useEffect} from 'react'
//import { createThread } from '../../util/feedback_util'
import {fetchAllWorkInstructions} from '../../../util/wi_util'
import {fetchAllUsers} from '../../../util/user_util'
import {updateThreadUsers} from '../../../util/feedback_util'

 const FeedbackUserManagement = ({thread,currentUserId,currentUser, closeModal}) =>{
    const [threadName, setThreadName] = useState('');
    const [users, setUsers] = useState([]); 
    const [selectedUsers, setSelectedUsers] = useState([]);

    useEffect(() => {
        const fetchWorkInstructions = async () => {
            try {

                const [ usersData] = await Promise.all([
                    fetchAllUsers()
                ]);
                setUsers(usersData);

            } catch (error) {
                console.error('Error fetching users:', error);
                // You might want to add error handling here (e.g., setting an error state)
            }
        };
        fetchWorkInstructions();
        let userIds = []
        for(let u in thread.Users){
            userIds.push(thread.Users[u]._id)
        }
        setSelectedUsers(userIds);
    }, []); 
    
    const updateUsers = () => {
        const selectedUserObjects = users
        .filter(user => selectedUsers.includes(user._id))
        .map(user => ({
            _id: user._id,
            username: user.username
        }));
        //selectedUserObjects.push({_id:currentUserId,username:currentUser})
        updateThreadUsers({users: selectedUserObjects, thread_id: thread.ThreadID}).then(response => {
            console.log(response);
            closeModal();
        }).catch(error => {
            console.error('Error updating thread users:', error);
        });
    }

    return (
        <div >
            <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px' }}>Select Users:</label>
                <div style={{border: '1px solid #ccc', borderRadius: '4px',  maxHeight: '200px', overflowY: 'auto',padding: '8px'}}>  
                {users.map((user) => (
                    <div 
                        key={user._id} 
                        style={{ display: 'flex',alignItems: 'center',padding: '4px 0'}}>
                        <input type="checkbox" id={`user-${user._id}`} disabled={user._id === currentUserId} value={user._id} checked={selectedUsers.includes(user._id) || user._id === currentUserId}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setSelectedUsers([...selectedUsers, user._id]);
                                    } else {
                                        setSelectedUsers(selectedUsers.filter(id => id !== user._id));
                                    }
                                }}
                                style={{ marginRight: '8px' }}
                        />
                        <label htmlFor={`user-${user._id}`}
                        style={{color: user._id === currentUserId ? '#666' : 'inherit'}}>
                        {user.username}
                        {user._id === currentUserId && '(You)'}
                        </label>    
                </div>
                ))}
                </div>
            </div>

            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
                <button onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
                        style={{padding: '10px 20px',backgroundColor: '#007bff',color: 'white',border: 'none',borderRadius: '4px',cursor: 'pointer',fontSize: '16px'}}
                        onClick={() => updateUsers()}>
                    Update Users
                </button>
            </div>
        </div>

    );
} 

export default FeedbackUserManagement;